import { useQuery } from '@tanstack/react-query';
import type { CleModele } from '@artosera/shared';
import { appelDeRequete, cleMetier } from './cles.js';
import { ventesApi } from './ventes.js';

/**
 * Un modèle de document de la galerie (fiche d'œuvre, certificat, liste de
 * prix, facture, avoir). La route vit sous `…/ventes/modeles/:cle` pour des
 * raisons d'histoire, mais elle appartient au module `documents-prestige`
 * (D21, ARTO-56) : elle reste ouverte quand `facturation` est coupée.
 *
 * Le modèle est CRÉÉ à la première lecture (`docs/dev/api.md` § 17.3) : la
 * liste n'est jamais vide, et chaque document a toujours un modèle à régler.
 * La clé de cache est celle qu'invalide `useModifierModeleVentes`.
 */
export function useModeleDocument(galerie: string, cle: CleModele) {
  return useQuery({
    // La même clé que `cleModele` de `ventes.ts`, qu'invalide l'enregistrement.
    queryKey: cleMetier(galerie, 'ventes', 'modele', cle),
    queryFn: (contexte) => ventesApi.modele(galerie, cle, appelDeRequete(contexte)),
  });
}
